var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "600" },
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          $event.preventDefault()
          return _vm.onenter.apply(null, arguments)
        },
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "290" },
          model: {
            value: _vm.dialog_edit,
            callback: function ($$v) {
              _vm.dialog_edit = $$v
            },
            expression: "dialog_edit",
          },
        },
        [
          _vm.model && _vm.model.track
            ? _c(
                "v-card",
                [
                  _c("v-card-title", { staticClass: "text-h5" }, [
                    _vm._v("Edit level: " + _vm._s(_vm.dialog_edit_index)),
                  ]),
                  _c("v-card-text", [
                    _vm._v("Select used colors and type of cauldron."),
                  ]),
                  _vm.model.track.products[_vm.dialog_edit_index]
                    ? _c("v-text-field", {
                        staticClass: "ma-3 mt-n2",
                        attrs: {
                          outlined: "",
                          dense: "",
                          type: "number",
                          label: "Points",
                        },
                        on: {
                          input: function ($event) {
                            return _vm.validateDialogPointsInput(
                              _vm.dialog_edit_index
                            )
                          },
                        },
                        model: {
                          value:
                            _vm.model.track.products[_vm.dialog_edit_index]
                              .points,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.model.track.products[_vm.dialog_edit_index],
                              "points",
                              $$v
                            )
                          },
                          expression:
                            "model.track.products[dialog_edit_index].points",
                        },
                      })
                    : _vm._e(),
                  _c("r-product-dropdown", {
                    staticClass: "ma-3 mt-n6",
                    attrs: {
                      model:
                        _vm.model.track.products[_vm.dialog_edit_index].product,
                      groups: _vm.groups_product,
                      label: "Product",
                      outlined: "",
                      dense: "",
                    },
                    on: {
                      "update:model": function ($event) {
                        return _vm.$set(
                          _vm.model.track.products[_vm.dialog_edit_index],
                          "product",
                          $event
                        )
                      },
                    },
                  }),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "red darken-1", text: "" },
                          on: {
                            click: function ($event) {
                              _vm.dialog_edit = false
                            },
                          },
                        },
                        [_vm._v("Close")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm.model && _vm.model.track
        ? _c(
            "v-card",
            [
              _c("v-card-title", [
                _c("span", { staticClass: "headline" }, [
                  _vm._v("Magic Spin Bundle (" + _vm._s(this.rules.name) + ")"),
                ]),
              ]),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-row",
                    { staticClass: "mb-4 pt-4", attrs: { dense: "" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "12", sm: "12" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              disabled: "",
                              label: "UID:",
                              "hide-details": "",
                              outlined: "",
                              dense: "",
                            },
                            model: {
                              value: _vm.model.uid,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.model,
                                  "uid",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "model.uid",
                            },
                          }),
                        ],
                        1
                      ),
                      _c("v-text-field", {
                        directives: [
                          { name: "ascii-only", rawName: "v-ascii-only" },
                        ],
                        staticClass: "mr-2",
                        attrs: { label: "Name" },
                        model: {
                          value: _vm.model.name,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.model,
                              "name",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "model.name",
                        },
                      }),
                      _c("v-text-field", {
                        directives: [
                          { name: "ascii-only", rawName: "v-ascii-only" },
                        ],
                        attrs: { label: "Key" },
                        model: {
                          value: _vm.model.key,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.model,
                              "key",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "model.key",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    { staticClass: "mt-3", attrs: { dense: "" } },
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "ma-0 pa-2",
                          attrs: {
                            width: "100%",
                            elevation: "0",
                            outlined: "",
                          },
                        },
                        [
                          _c(
                            "v-card-actions",
                            {
                              staticClass: "ma-0 pa-1",
                              attrs: { width: "100%", elevation: "0" },
                            },
                            [
                              _c(
                                "v-card-title",
                                { staticClass: "orange--text pa-0 ma-0 ml-1" },
                                [_vm._v("Product Track")]
                              ),
                              _c("v-spacer"),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "green--text",
                                  attrs: {
                                    icon: "",
                                    elevation: "0",
                                    color: "white",
                                    dense: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.row_add()
                                    },
                                  },
                                },
                                [_c("v-icon", [_vm._v("mdi-plus")])],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-card-actions",
                            {
                              staticClass: "ma-0 pa-1",
                              attrs: { width: "100%", elevation: "0" },
                            },
                            [
                              _c("v-data-table", {
                                staticStyle: {
                                  "white-space": "nowrap",
                                  width: "100%",
                                },
                                attrs: {
                                  headers: _vm.headers,
                                  items: _vm.model.track.products,
                                  height:
                                    _vm.model.track.products.length > 7
                                      ? 32 * 7 + 32 + 16
                                      : undefined,
                                  "item-key": "none",
                                  "disable-pagination": "",
                                  "hide-default-footer": "",
                                  dense: "",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "item.product",
                                      fn: function ({ item }) {
                                        return [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.getProductName(item.product)
                                              ) +
                                              " "
                                          ),
                                        ]
                                      },
                                    },
                                    {
                                      key: "item.points",
                                      fn: function ({ item }) {
                                        return [
                                          _vm._v(
                                            " " + _vm._s(item.points) + " "
                                          ),
                                        ]
                                      },
                                    },
                                    {
                                      key: "item.actions",
                                      fn: function ({ item, index }) {
                                        return [
                                          _c(
                                            "v-icon",
                                            {
                                              staticClass: "mr-2",
                                              attrs: { small: "" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.row_edit(index)
                                                },
                                              },
                                            },
                                            [_vm._v("mdi-pencil")]
                                          ),
                                          _c(
                                            "v-icon",
                                            {
                                              staticClass: "mr-2",
                                              attrs: { small: "" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.row_moveup(index)
                                                },
                                              },
                                            },
                                            [_vm._v("mdi-arrow-up-thick")]
                                          ),
                                          _c(
                                            "v-icon",
                                            {
                                              staticClass: "mr-2",
                                              attrs: { small: "" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.row_movedown(index)
                                                },
                                              },
                                            },
                                            [_vm._v("mdi-arrow-down-thick")]
                                          ),
                                          _c(
                                            "v-icon",
                                            {
                                              staticClass: "mr-2",
                                              attrs: { small: "" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.row_remove(index)
                                                },
                                              },
                                            },
                                            [_vm._v("mdi-delete")]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2898160967
                                ),
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-card",
                        {
                          staticClass: "ma-0 pa-2 mt-2",
                          attrs: {
                            width: "100%",
                            elevation: "0",
                            outlined: "",
                          },
                        },
                        [
                          _c(
                            "v-card-title",
                            { staticClass: "red--text pa-0 ma-0 ml-1 mb-2" },
                            [_vm._v("Guards")]
                          ),
                          _c(
                            "v-expansion-panels",
                            [
                              _c("r-guard-panel", {
                                attrs: {
                                  model: _vm.model.guard,
                                  title: "Guard Config",
                                },
                                on: {
                                  "update:model": function ($event) {
                                    return _vm.$set(_vm.model, "guard", $event)
                                  },
                                },
                              }),
                              _c("r-guard-money-panel", {
                                attrs: {
                                  model: _vm.model.guardMoney,
                                  title: "Guard Money",
                                },
                                on: {
                                  "update:model": function ($event) {
                                    return _vm.$set(
                                      _vm.model,
                                      "guardMoney",
                                      $event
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "blue darken-1", text: "" },
                      on: { click: _vm.cancel },
                    },
                    [_vm._v(" Cancel ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "blue darken-1", text: "" },
                      on: { click: _vm.save },
                    },
                    [_vm._v(" Save ")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }